import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { startCartSync } from './store/cartSync';
import { getTotals } from './store/reducers/cartSlice';
import { Toaster } from 'react-hot-toast';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
const root = ReactDOM.createRoot(document.getElementById('root'));

store.dispatch(getTotals());
startCartSync();
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<Toaster
					position="top-center"
					reverseOrder={false}
					gutter={8}
					containerStyle={{
						top: '6rem',
						left: '20px',
						right: '20px'
					}}
					toastOptions={{
						duration: 5000,
						style: {
							background: '#fff',
							color: '#363636',
							padding: '0.5rem',
							borderRadius: '0.5rem',
							boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
						},
						success: {
							iconTheme: {
								primary: '#10B981',
								secondary: '#fff',
							},
						},
						error: {
							iconTheme: {
								primary: '#EF4444',
								secondary: '#fff',
							},
						},
					}}
				/>
				<PayPalScriptProvider deferLoading={true}>
					<App />
				</PayPalScriptProvider>
			</Provider>
			</QueryClientProvider>
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
